import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  BarChart, 
  LineChart,
  AreaChart,
  MixedLineBarChart,
  PieChart,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";


export default function Stats() {
  const { 
    activeSeriesName, setActiveSeriesName
  } = useContext(GlobalContext);
  // const [activeHref, setActiveHref] = useState("/news");

  return (
    <>
      <Container
        header={<Header variant="h1"> {`${activeSeriesName} Stats`} </Header>}
      >
        <BarChart
          series={[
            {
              title: "Site 1",
              type: "bar",
              data: [
                { x: new Date(1601042400000), y: 34503 },
                { x: new Date(1601049600000), y: 25832 },
                { x: new Date(1601056800000), y: 4012 },
                { x: new Date(1601064000000), y: -5602 },
                { x: new Date(1601071200000), y: 17839 }
              ],
              valueFormatter: e =>
                "$" + e.toLocaleString("en-AU")
            },
            {
              title: "Average revenue",
              type: "threshold",
              y: 19104,
              valueFormatter: e =>
                "$" + e.toLocaleString("en-AU")
            }
          ]}
          xDomain={[
            new Date(1601042400000),
            new Date(1601049600000),
            new Date(1601056800000),
            new Date(1601064000000),
            new Date(1601071200000)
          ]}
          yDomain={[-10000, 40000]}
          i18nStrings={{
            filterLabel: "Filter displayed data",
            filterPlaceholder: "Filter data",
            filterSelectedAriaLabel: "selected",
            detailPopoverDismissAriaLabel: "Dismiss",
            legendAriaLabel: "Legend",
            chartAriaRoleDescription: "line chart",
            // xTickFormatter: e =>
            //   e.toLocaleDateString("en-AU", {
            //       month: "short",
            //       day: "numeric",
            //       hour: "numeric",
            //       minute: "numeric",
            //       hour12: !1
            //     })
            //     .split(",")
            //     .join("\n"),
            // yTickFormatter: function o(e) {
            //   return Math.abs(e) >= 1e9
            //     ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
            //         "G"
            //     : Math.abs(e) >= 1e6
            //     ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
            //       "M"
            //     : Math.abs(e) >= 1e3
            //     ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
            //       "K"
            //     : e.toFixed(2);
            // }
          }}
          ariaLabel="Single data series line chart"
          errorText="Error loading data."
          height={300}
          loadingText="Loading chart"
          recoveryText="Retry"
          xTitle="Time (UTC)"
          yTitle="Revenue (USD)"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No data available</b>
              <Box variant="p" color="inherit">
                There is no data available
              </Box>
            </Box>
          }
          noMatch={
            <Box textAlign="center" color="inherit">
              <b>No matching data</b>
              <Box variant="p" color="inherit">
                There is no matching data to display
              </Box>
              <Button>Clear filter</Button>
            </Box>
          }
        />
        <LineChart
          series={[
            {
              title: "Site 1",
              type: "line",
              data: [
                { x: new Date(1600956000000), y: 58020 },
                { x: new Date(1600956900000), y: 102402 },
                { x: new Date(1600957800000), y: 104920 },
                { x: new Date(1600958700000), y: 94031 },
                { x: new Date(1600959600000), y: 125021 },
                { x: new Date(1600960500000), y: 159219 },
                { x: new Date(1600961400000), y: 193082 },
                { x: new Date(1600962300000), y: 162592 },
                { x: new Date(1600963200000), y: 274021 },
                { x: new Date(1600964100000), y: 264286 },
                { x: new Date(1600965000000), y: 289210 },
                { x: new Date(1600965900000), y: 256362 },
                { x: new Date(1600966800000), y: 257306 },
                { x: new Date(1600967700000), y: 186776 },
                { x: new Date(1600968600000), y: 294020 },
                { x: new Date(1600969500000), y: 385975 },
                { x: new Date(1600970400000), y: 486039 },
                { x: new Date(1600971300000), y: 490447 },
                { x: new Date(1600972200000), y: 361845 },
                { x: new Date(1600973100000), y: 339058 },
                { x: new Date(1600974000000), y: 298028 },
                { x: new Date(1600974900000), y: 231902 },
                { x: new Date(1600975800000), y: 224558 },
                { x: new Date(1600976700000), y: 253901 },
                { x: new Date(1600977600000), y: 102839 },
                { x: new Date(1600978500000), y: 234943 },
                { x: new Date(1600979400000), y: 204405 },
                { x: new Date(1600980300000), y: 190391 },
                { x: new Date(1600981200000), y: 183570 },
                { x: new Date(1600982100000), y: 162592 },
                { x: new Date(1600983000000), y: 148910 },
                { x: new Date(1600983900000), y: 229492 },
                { x: new Date(1600984800000), y: 293910 }
              ],
              valueFormatter: function o(e) {
                return Math.abs(e) >= 1e9
                  ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                      "G"
                  : Math.abs(e) >= 1e6
                  ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                    "M"
                  : Math.abs(e) >= 1e3
                  ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                    "K"
                  : e.toFixed(2);
              }
            },
            {
              title: "Peak hours",
              type: "threshold",
              x: new Date(1600974600000)
            }
          ]}
          xDomain={[
            new Date(1600956000000),
            new Date(1600984800000)
          ]}
          yDomain={[0, 500000]}
          i18nStrings={{
            filterLabel: "Filter displayed data",
            filterPlaceholder: "Filter data",
            filterSelectedAriaLabel: "selected",
            detailPopoverDismissAriaLabel: "Dismiss",
            legendAriaLabel: "Legend",
            chartAriaRoleDescription: "line chart",
            xTickFormatter: e =>
              e
                .toLocaleDateString("en-AU", {
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: !1
                })
                .split(",")
                .join("\n"),
            yTickFormatter: function o(e) {
              return Math.abs(e) >= 1e9
                ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                    "G"
                : Math.abs(e) >= 1e6
                ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                  "M"
                : Math.abs(e) >= 1e3
                ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                  "K"
                : e.toFixed(2);
            }
          }}
          ariaLabel="Single data series line chart"
          errorText="Error loading data."
          height={300}
          hideFilter
          hideLegend
          loadingText="Loading chart"
          recoveryText="Retry"
          xScaleType="time"
          xTitle="Time (UTC)"
          yTitle="Bytes transferred"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No data available</b>
              <Box variant="p" color="inherit">
                There is no data available
              </Box>
            </Box>
          }
          noMatch={
            <Box textAlign="center" color="inherit">
              <b>No matching data</b>
              <Box variant="p" color="inherit">
                There is no matching data to display
              </Box>
              <Button>Clear filter</Button>
            </Box>
          }
        />
        <AreaChart
          series={[
            {
              title: "Network 1",
              type: "area",
              data: [
                { x: new Date(1600956000000), y: 114489 },
                { x: new Date(1600956900000), y: 136935 },
                { x: new Date(1600957800000), y: 141026 },
                { x: new Date(1600958700000), y: 123288 },
                { x: new Date(1600959600000), y: 121956 },
                { x: new Date(1600960500000), y: 119868 },
                { x: new Date(1600961400000), y: 132326 },
                { x: new Date(1600962300000), y: 126879 },
                { x: new Date(1600963200000), y: 138543 },
                { x: new Date(1600964100000), y: 144309 },
                { x: new Date(1600965000000), y: 121118 },
                { x: new Date(1600965900000), y: 113430 },
                { x: new Date(1600966800000), y: 135911 },
                { x: new Date(1600967700000), y: 113126 },
                { x: new Date(1600968600000), y: 119538 },
                { x: new Date(1600969500000), y: 124338 },
                { x: new Date(1600970400000), y: 133884 },
                { x: new Date(1600971300000), y: 135473 },
                { x: new Date(1600972200000), y: 131187 },
                { x: new Date(1600973100000), y: 136176 },
                { x: new Date(1600974000000), y: 144422 },
                { x: new Date(1600974900000), y: 115392 },
                { x: new Date(1600975800000), y: 139307 },
                { x: new Date(1600976700000), y: 128517 },
                { x: new Date(1600977600000), y: 107160 },
                { x: new Date(1600978500000), y: 110283 },
                { x: new Date(1600979400000), y: 134513 },
                { x: new Date(1600980300000), y: 111311 },
                { x: new Date(1600981200000), y: 142686 },
                { x: new Date(1600982100000), y: 130652 },
                { x: new Date(1600983000000), y: 149418 },
                { x: new Date(1600983900000), y: 121923 }
              ],
              valueFormatter: function o(e) {
                return Math.abs(e) >= 1e9
                  ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                      "G"
                  : Math.abs(e) >= 1e6
                  ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                    "M"
                  : Math.abs(e) >= 1e3
                  ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                    "K"
                  : e.toFixed(2);
              }
            },
            {
              title: "Network 2",
              type: "area",
              data: [
                { x: new Date(1600956000000), y: 10413 },
                { x: new Date(1600956900000), y: 26582 },
                { x: new Date(1600957800000), y: 45593 },
                { x: new Date(1600958700000), y: 65918 },
                { x: new Date(1600959600000), y: 76223 },
                { x: new Date(1600960500000), y: 62385 },
                { x: new Date(1600961400000), y: 83330 },
                { x: new Date(1600962300000), y: 127209 },
                { x: new Date(1600963200000), y: 104802 },
                { x: new Date(1600964100000), y: 145899 },
                { x: new Date(1600965000000), y: 121375 },
                { x: new Date(1600965900000), y: 112968 },
                { x: new Date(1600966800000), y: 145263 },
                { x: new Date(1600967700000), y: 139562 },
                { x: new Date(1600968600000), y: 128343 },
                { x: new Date(1600969500000), y: 122774 },
                { x: new Date(1600970400000), y: 145396 },
                { x: new Date(1600971300000), y: 176509 },
                { x: new Date(1600972200000), y: 201006 },
                { x: new Date(1600973100000), y: 196538 },
                { x: new Date(1600974000000), y: 213773 },
                { x: new Date(1600974900000), y: 205076 },
                { x: new Date(1600975800000), y: 216369 },
                { x: new Date(1600976700000), y: 159386 },
                { x: new Date(1600977600000), y: 238852 },
                { x: new Date(1600978500000), y: 207500 },
                { x: new Date(1600979400000), y: 187110 },
                { x: new Date(1600980300000), y: 314165 },
                { x: new Date(1600981200000), y: 165653 },
                { x: new Date(1600982100000), y: 175584 },
                { x: new Date(1600983000000), y: 230042 },
                { x: new Date(1600983900000), y: 293879 }
              ],
              valueFormatter: function o(e) {
                return Math.abs(e) >= 1e9
                  ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                      "G"
                  : Math.abs(e) >= 1e6
                  ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                    "M"
                  : Math.abs(e) >= 1e3
                  ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                    "K"
                  : e.toFixed(2);
              }
            }
          ]}
          xDomain={[
            new Date(1600956000000),
            new Date(1600983900000)
          ]}
          yDomain={[0, 500000]}
          i18nStrings={{
            filterLabel: "Filter displayed data",
            filterPlaceholder: "Filter data",
            filterSelectedAriaLabel: "selected",
            detailPopoverDismissAriaLabel: "Dismiss",
            legendAriaLabel: "Legend",
            chartAriaRoleDescription: "line chart",
            detailTotalLabel: "Total",
            xTickFormatter: e =>
              e
                .toLocaleDateString("en-AU", {
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: !1
                })
                .split(",")
                .join("\n"),
            yTickFormatter: function o(e) {
              return Math.abs(e) >= 1e9
                ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                    "G"
                : Math.abs(e) >= 1e6
                ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                  "M"
                : Math.abs(e) >= 1e3
                ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                  "K"
                : e.toFixed(2);
            }
          }}
          ariaLabel="Stacked area chart"
          errorText="Error loading data."
          height={300}
          hideFilter
          loadingText="Loading chart"
          recoveryText="Retry"
          xScaleType="time"
          xTitle="Time (UTC)"
          yTitle="Bytes transferred"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No data available</b>
              <Box variant="p" color="inherit">
                There is no data available
              </Box>
            </Box>
          }
          noMatch={
            <Box textAlign="center" color="inherit">
              <b>No matching data</b>
              <Box variant="p" color="inherit">
                There is no matching data to display
              </Box>
              <Button>Clear filter</Button>
            </Box>
          }
        />
        <MixedLineBarChart
          series={[
            {
              title: "Costs",
              type: "bar",
              data: [
                { x: "Jun 2019", y: 6562 },
                { x: "Jul 2019", y: 8768 },
                { x: "Aug 2019", y: 9742 },
                { x: "Sep 2019", y: 10464 },
                { x: "Oct 2019", y: 16777 },
                { x: "Nov 2019", y: 9956 },
                { x: "Dec 2019", y: 5876 }
              ],
              valueFormatter: e =>
                "$" + e.toLocaleString("en-AU")
            },
            {
              title: "Costs last year",
              type: "line",
              data: [
                { x: "Jun 2019", y: 5373 },
                { x: "Jul 2019", y: 7563 },
                { x: "Aug 2019", y: 7900 },
                { x: "Sep 2019", y: 12342 },
                { x: "Oct 2019", y: 14311 },
                { x: "Nov 2019", y: 11830 },
                { x: "Dec 2019", y: 8505 }
              ],
              valueFormatter: e =>
                "$" + e.toLocaleString("en-AU")
            },
            {
              title: "Budget",
              type: "threshold",
              y: 12000,
              valueFormatter: e =>
                "$" + e.toLocaleString("en-AU")
            },
            {
              title: "Peak cost",
              type: "threshold",
              x: "Sep 2019"
            }
          ]}
          xDomain={[
            "Jun 2019",
            "Jul 2019",
            "Aug 2019",
            "Sep 2019",
            "Oct 2019",
            "Nov 2019",
            "Dec 2019"
          ]}
          yDomain={[0, 20000]}
          i18nStrings={{
            filterLabel: "Filter displayed data",
            filterPlaceholder: "Filter data",
            filterSelectedAriaLabel: "selected",
            detailPopoverDismissAriaLabel: "Dismiss",
            legendAriaLabel: "Legend",
            chartAriaRoleDescription: "line chart",
            yTickFormatter: function o(e) {
              return Math.abs(e) >= 1e9
                ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                    "G"
                : Math.abs(e) >= 1e6
                ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                  "M"
                : Math.abs(e) >= 1e3
                ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                  "K"
                : e.toFixed(2);
            }
          }}
          ariaLabel="Mixed bar chart"
          errorText="Error loading data."
          height={300}
          loadingText="Loading chart"
          recoveryText="Retry"
          xScaleType="categorical"
          xTitle="Budget month"
          yTitle="Costs (USD)"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No data available</b>
              <Box variant="p" color="inherit">
                There is no data available
              </Box>
            </Box>
          }
          noMatch={
            <Box textAlign="center" color="inherit">
              <b>No matching data</b>
              <Box variant="p" color="inherit">
                There is no matching data to display
              </Box>
              <Button>Clear filter</Button>
            </Box>
          }
        />
        <PieChart
          data={[
            {
              title: "Running",
              value: 60,
              lastUpdate: "Dec 7, 2020"
            },
            {
              title: "Failed",
              value: 30,
              lastUpdate: "Dec 6, 2020"
            },
            {
              title: "In-progress",
              value: 10,
              lastUpdate: "Dec 6, 2020"
            },
            {
              title: "Pending",
              value: 0,
              lastUpdate: "Dec 7, 2020"
            }
          ]}
          detailPopoverContent={(datum, sum) => [
            { key: "Resource count", value: datum.value },
            {
              key: "Percentage",
              value: `${((datum.value / sum) * 100).toFixed(
                0
              )}%`
            },
            { key: "Last update on", value: datum.lastUpdate }
          ]}
          segmentDescription={(datum, sum) =>
            `${datum.value} units, ${(
              (datum.value / sum) *
              100
            ).toFixed(0)}%`
          }
          i18nStrings={{
            detailsValue: "Value",
            detailsPercentage: "Percentage",
            filterLabel: "Filter displayed data",
            filterPlaceholder: "Filter data",
            filterSelectedAriaLabel: "selected",
            detailPopoverDismissAriaLabel: "Dismiss",
            legendAriaLabel: "Legend",
            chartAriaRoleDescription: "pie chart",
            segmentAriaRoleDescription: "segment"
          }}
          ariaDescription="Pie chart showing how many resources are currently in which state."
          ariaLabel="Pie chart"
          errorText="Error loading data."
          loadingText="Loading chart"
          recoveryText="Retry"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No data available</b>
              <Box variant="p" color="inherit">
                There is no data available
              </Box>
            </Box>
          }
          noMatch={
            <Box textAlign="center" color="inherit">
              <b>No matching data</b>
              <Box variant="p" color="inherit">
                There is no matching data to display
              </Box>
              <Button>Clear filter</Button>
            </Box>
          }
        />
      </Container>
    </>    
  );
}
